import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  Button,
  TextArea,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneRestaurant } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const restaurant = getOneRestaurant();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const restaurant_id = restaurant?.restaurant_id;
  const [title, setTitle] = useState(restaurant?.name);
  const [thumbnail, setThumbnail] = useState(restaurant?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(restaurant?.image_cdn_id);
  const [openDays, setOpenDays] = useState(restaurant?.opened_days);
  const [openedAt, setOpenedAt] = useState(restaurant?.opened_at);
  const [closedAt, setClosedAt] = useState(restaurant?.closed_at);
  const [rating, setRating] = useState(restaurant?.rating);
  const [email, setEmail] = useState(restaurant?.email_address);
  const [payLink, setPayLink] = useState(restaurant?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(restaurant?.phone_number);
  const [whatsapp, setWhatsapp] = useState(restaurant?.whatsapp);
  const [facebook, setFacebook] = useState(restaurant?.facebook);
  const [twitter, setTwitter] = useState(restaurant?.twitter);
  const [instagram, setInstagram] = useState(restaurant?.instagram);
  const [youtube, setYoutube] = useState(restaurant?.youtube);
  const [hashtags, setHashtags] = useState(restaurant?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState(
    restaurant?.google_map_code
  );
  const [latitude, setLatitude] = useState(restaurant?.latitude);
  const [longitude, setLongitude] = useState(restaurant?.longitude);
  const [formattedAddress, setFormattedAddress] = useState(
    restaurant?.formatted_address
  );
  const [promoted, setPromoted] = useState(
    restaurant?.promoted ? restaurant?.promoted : "no"
  );
  const [restaurantStatus, setRestaurantStatus] = useState(restaurant?.status);
  const [description, setDescription] = useState(restaurant?.description);
  const [collection, setCollection] = useState(
    restaurant?.HotelRestauDescriptions
      ? restaurant?.HotelRestauDescriptions
      : []
  );
  const [expo, setExpo] = useState(restaurant?.expo);
  const [exteriorImages, setExteriorImages] = useState(
    restaurant?.exterior_images
  );
  const [showExtImages, setShowExtImages] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState(restaurant?.type);
  const [pricing, setPricing] = useState(restaurant?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const [menu, setMenu] = useState(
    restaurant?.RestaurantMenus ? restaurant?.RestaurantMenus?.thumbnail : null
  );
  const [menu_id, setMenuId] = useState(
    restaurant?.RestaurantMenus
      ? restaurant?.RestaurantMenus?.image_cdn_id
      : null
  );

  const restaurantRoutes = "/data/restaurant";

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) responses(true, "Image Required");
    else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : restaurant?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      name: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      type: type ? type : "african",
      description,
      city_level: "level",
      opened_days: openDays,
      opened_at: openedAt,
      closed_at: closedAt,
      rating,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: hashtags,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: restaurantStatus,
      promoted,
      subdata: collection?.length > 0 ? collection : [],
      menu: menu
        ? {
            name: "...",
            category: "...",
            description: "...",
            thumbnail: menu,
            image_cdn_id: menu_id,
          }
        : null,
      expo,
      exterior_images: exteriorImages?.filter((x) => x?.thumbnail !== null),
      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: restaurant_id,
      data,
      content: _TYPES_.RESTAURANT,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  // design tokens
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-3 sm:p-4";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>
        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: restaurantRoutes }} />
        </div>
        <div className="mb-4">
          <DashboardIntro
            props={{ intro: "Edit Restaurant", name: entry_label }}
          />
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <ModalDetails
          onClick={() => setShowModal(false)}
          showModal={showModal}
          collection={collection}
          setCollection={setCollection}
        />
        <ExteriorImages
          exteriorImages={exteriorImages}
          setExteriorImages={setExteriorImages}
          showModal={showExtImages}
          onClick={() => setShowExtImages(false)}
        />

        <form onSubmit={updateOneEventHandler} className="space-y-4">
          <div className={`${card} ${sectionPad}`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-xs font-semibold mb-2">Profile Image</p>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
                />
              </div>
              <div>
                <p className="text-xs font-semibold mb-2">Menu PDF</p>
                <ImageKitUpload
                  thumbnail={menu}
                  thumbnailId={menu_id}
                  setThumbnail={setMenu}
                  setThumbnailId={setMenuId}
                  folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
                />
              </div>
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Restaurant Details" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "type",
                  title: "Type",
                  type: "text",
                  preselect: type !== null ? [{ name: type }] : null,
                  option: [
                    "african",
                    "american",
                    "south american",
                    "european",
                    "asian",
                    "oceanian",
                    "intercontinental",
                  ],
                  onChange: (e) => {
                    setType(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress ? formattedAddress : "",
                  onChange: (e) => {
                    setFormattedAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Date & Time" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "opened_days",
                  title: "Open Days",
                  type: "text",
                  value: openDays ? openDays : "",
                  onChange: (e) => {
                    setOpenDays(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "opened_at",
                  title: "Opens At",
                  type: "time",
                  value: openedAt ? openedAt : "",
                  onChange: (e) => {
                    setOpenedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "closed_at",
                  title: "Closes At",
                  type: "time",
                  value: closedAt ? closedAt : "",
                  onChange: (e) => {
                    setClosedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "rating",
                  title: "Rating",
                  type: "text",
                  value: rating ? rating : "",
                  onChange: (e) => {
                    setRating(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Pricing" }} />
            <Pricing pricing={pricing} setPricing={setPricing} />
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <div className="flex justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode ? googleMapCode : "",
                  onChange: (e) => {
                    setGoogleMapCode(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude ? latitude : "",
                  onChange: (e) => {
                    setLatitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude ? longitude : "",
                  onChange: (e) => {
                    setLongitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <Select
                props={{
                  id: "restaurant_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  preselect:
                    restaurantStatus !== null
                      ? [
                          {
                            name:
                              restaurantStatus === 1 ? "visible" : "invisible",
                          },
                        ]
                      : null,
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setRestaurantStatus(1);
                    else setRestaurantStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  preselect: promoted !== null ? [{ name: promoted }] : null,
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  preselect:
                    expo !== null
                      ? [{ name: expo === 0 ? "no" : "yes" }]
                      : null,
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-between">
              <MyButton
                className={`${btnBase} ${btnPrimary}`}
                onClick={() => setShowDescriptionModal(true)}
                title="Generate Description"
              />
            </div>
            <div className="mt-3">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <Button
                props={{
                  type: "button",
                  title: "Change Inter. / Exter. Images",
                  category: "default",
                  action: "edit",
                  onClick: () => setShowExtImages(true),
                }}
              />
              <Button
                props={{
                  type: "button",
                  title: "Change More Details",
                  category: "default",
                  action: "edit",
                  onClick: () => setShowModal(true),
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <MyActionButton
              loading={loading}
              title="Save Changes"
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
